(function($) {
    'use strict';

    var BP = {
        init: function(options) {
            var $wrapper;

            if (typeof options.wrapper === 'string') {
                var prop = options.wrapper.indexOf('.') > -1 ? 'class' : 'id';

                $wrapper = $('<div />')
                    .prop(prop, options.wrapper.substring(1))
                    .appendTo('body');
            } else {
                $wrapper = options.wrapper;
            }

            if (!$wrapper.size()) {
                // Breakpoint wrapper not found.
                return;
            }

            document.BP = {
                wrapper: $wrapper,
                sizes: options.sizes,
                currentIndex: -1
            };

            $.each(options.sizes, function() {
                var $size = $('<div/>');

                $size.addClass(this).appendTo(document.BP.wrapper);
            });

            BP.bindEvents();
            BP.setCurrentIndex();
        },

        bindEvents: function() {
            $(window).on('resize', function() {
                BP.setCurrentIndex();
            });
        },

        setCurrentIndex: function() {
            var $breakpoint = document.BP.wrapper.children().filter(':visible'),
                oldIndex = document.BP.currentIndex,
                isFirstRun,
                isDesktop,
                size;

            size = $breakpoint.size() ? $breakpoint.prop('class') : '';
            document.BP.currentIndex = BP.sizeIndex(size);

            if (document.BP.currentIndex < 0) {
                document.BP.currentIndex = document.BP.sizes.length;
                isDesktop = true;
            }

            isFirstRun = oldIndex === -1;

            if (isFirstRun && isDesktop) {
                return;
            }

            if (oldIndex !== document.BP.currentIndex) {
                $.event.trigger('breakpoint.changed');
            }
        },

        sizeIndex: function(size) {
            return $.inArray(size, document.BP.sizes);
        },

        isSize: function(operator, size) {
            var index = BP.sizeIndex(size),
                operators = {
                    '==': function(compare) {
                        return document.BP.currentIndex === compare;
                    },
                    '<': function(compare) {
                        return document.BP.currentIndex < compare;
                    },
                    '>': function(compare) {
                        return document.BP.currentIndex > compare;
                    },
                    '<=': function(compare) {
                        return document.BP.currentIndex <= compare;
                    },
                    '>=': function(compare) {
                        return document.BP.currentIndex >= compare;
                    }
                };

            return operators[operator](index);
        }
    };

    $.breakpoint = {
        init: function(options) {
            options = $.extend(
                {
                    wrapper: '#js-grid-breakpoints',
                    sizes: []
                },
                options
            );

            BP.init(options);
        },

        size: function(operator, size) {
            return BP.isSize(operator, size);
        }
    };
})(jQuery);
